import React from 'react'
import { mediaURL } from 'src/consumer/services'
import { getParseDataFromHtmlString } from 'src/consumer/helpers/utilFunctions'

export default function SignatureComponent({
  signatureSize,
  signatureMediaId,
  doctorName,
  richText,
  showPractitionerName = true,
  practitionerNameCase = 'small',
}) {
  let signatureMultiplier = 1
  switch (signatureSize) {
    case 'sm':
      signatureMultiplier = 0.75
      break
    case 'md':
      signatureMultiplier = 1
      break
    case 'lg':
      signatureMultiplier = 1.2
      break
    case 'xl':
      signatureMultiplier = 1.5
      break
    case 'xxl':
      signatureMultiplier = 1.75
      break
    case 'xxxl':
      signatureMultiplier = 2
      break
    default:
      signatureMultiplier = 1
  }

  const displayName =
    showPractitionerName !== false && doctorName
      ? practitionerNameCase === 'capital'
        ? String(doctorName).toUpperCase()
        : String(doctorName)
      : null
  const hasRichText = richText && String(richText).trim().length > 0
  const parsedRichText = hasRichText
    ? getParseDataFromHtmlString(String(richText).trim(), { preserveEmptyParagraphs: true })
    : null

  return (
    <div>
      <img
        style={{
          height: `${50 * signatureMultiplier}px`,
          width: `${100 * signatureMultiplier}px`,
          marginBottom: '10px',
        }}
        src={`${mediaURL}${signatureMediaId}`}
        alt="doctor's signature"
      />
      {displayName && <div style={{ marginBottom: hasRichText ? '6px' : 0 }}>{displayName}</div>}
      {parsedRichText && (
        <div
          className="signature-rich-text tiptap-content"
          style={{
            fontSize: '13px',
            lineHeight: 1.5,
            wordWrap: 'break-word',
          }}
        >
          {parsedRichText}
        </div>
      )}
    </div>
  )
}
